export default function HelpGenieLogo({ size = 40 }: { size?: number }) {
  return (
    <img src="/helpgenie_logo.png" alt="Help Genie Logo" width={size} style={{ display: "block", height: "auto" }} />
  );
}
